import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { DataModelApiService } from '../../api/data-model.api'
import { ReusableUiTemplateDataModelActions } from '../actions/reusable-ui-template-data-model.actions'

const reusableUiTemplateDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.ReusableTemplate,
  {
    load: ReusableUiTemplateDataModelActions.loadEntities,
    loadSuccess: ReusableUiTemplateDataModelActions.loadEntitiesSuccess,
    loadFailure: ReusableUiTemplateDataModelActions.loadEntitiesFailure,
    add: ReusableUiTemplateDataModelActions.addEntity,
    addSuccess: ReusableUiTemplateDataModelActions.addEntitySuccess,
    addFailure: ReusableUiTemplateDataModelActions.addEntityFailure,
    edit: ReusableUiTemplateDataModelActions.editEntity,
    editSuccess: ReusableUiTemplateDataModelActions.editEntitySuccess,
    editFailure: ReusableUiTemplateDataModelActions.editEntityFailure,
    addAttribute: ReusableUiTemplateDataModelActions.addAttribute,
    addAttributeSuccess: ReusableUiTemplateDataModelActions.addAttributeSuccess,
    addAttributeFailure: ReusableUiTemplateDataModelActions.addAttributeFailure,
    editAttribute: ReusableUiTemplateDataModelActions.editAttribute,
    editAttributeSuccess: ReusableUiTemplateDataModelActions.editAttributeSuccess,
    editAttributeFailure: ReusableUiTemplateDataModelActions.editAttributeFailure,
    requestDeleteEntity: ReusableUiTemplateDataModelActions.deleteEntityRequested,
    deleteEntity: ReusableUiTemplateDataModelActions.deleteEntity,
    deleteEntitySuccess: ReusableUiTemplateDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: ReusableUiTemplateDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: ReusableUiTemplateDataModelActions.deleteAttributeRequested,
    deleteAttribute: ReusableUiTemplateDataModelActions.deleteAttribute,
    deleteAttributeSuccess: ReusableUiTemplateDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: ReusableUiTemplateDataModelActions.deleteAttributeFailure,
    resetErrors: ReusableUiTemplateDataModelActions.resetErrors,
    resetErrorsSuccess: ReusableUiTemplateDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: ReusableUiTemplateDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess:
      ReusableUiTemplateDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure:
      ReusableUiTemplateDataModelActions.updateAttributeValidatorsFailure,
  },
  DataModelApiService
)

export const reusableUiTemplateLoadEntities$ = reusableUiTemplateDataModelBasicEffects.loadEntities$
export const reusableUiTemplateAddEntity$ = reusableUiTemplateDataModelBasicEffects.addEntity$
export const reusableUiTemplateEditEntity$ = reusableUiTemplateDataModelBasicEffects.editEntity$
export const reusableUiTemplateAddAttribute$ = reusableUiTemplateDataModelBasicEffects.addAttribute$
export const reusableUiTemplateEditAttribute$ =
  reusableUiTemplateDataModelBasicEffects.editAttribute$
export const reusableUiTemplateSetNewEntityAsAttribute$ =
  reusableUiTemplateDataModelBasicEffects.setNewEntityAsAttribute$
export const reusableUiTemplateStartDeleteEntity$ =
  reusableUiTemplateDataModelBasicEffects.startDeleteEntity$
export const reusableUiTemplateDeleteEntity$ = reusableUiTemplateDataModelBasicEffects.deleteEntity$
export const reusableUiTemplateStartDeleteAttribute$ =
  reusableUiTemplateDataModelBasicEffects.startDeleteAttribute$
export const reusableUiTemplateDeleteAttribute$ =
  reusableUiTemplateDataModelBasicEffects.deleteAttribute$
export const reusableUiTemplateResetErrors$ = reusableUiTemplateDataModelBasicEffects.resetErrors$
export const reusableUiTemplateUpdateAttributeValidators$ =
  reusableUiTemplateDataModelBasicEffects.updateAttributeValidators$
